export default __webpack_public_path__ + "static/media/ExportIcon.ff3fe52c.svg";